import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Testimonials = () => {
  const [sectionRef, sectionVisible] = useScrollAnimation(0.2);
  const featuredClients = [
    {
      name: "A. Shridhar",
      logo: "/images/logo/ashridhar.png"
    },
    {
      name: "Adani",
      logo: "/images/logo/adani.png"
    },
    {
      name: "Maruti Bitumen",
      logo: "/images/logo/maruti_bitumen.png"
    },
    {
      name: "Bajaj Foods",
      logo: "/images/logo/bajaj_foods.png"
    },
    {
      name: "Gateway Group",
      logo: "/images/logo/gateway.png"
    },
    {
      name: "Riddhi Siddhi Gluco Biols",
      logo: "/images/logo/riddhi_siddhi.png"
    },
    {
      name: "Mission Health",
      logo: "/images/logo/mission_health.png"
    },
    {
      name: "Tanishq",
      logo: "/images/logo/tanishq.png"
    },
    {
      name: "Sharda Steel",
      logo: "/images/logo/sharda_steel.png"
    },
    { name: "Elecon Engineering", logo: "/images/logo/elecon.png" }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div
        ref={sectionRef}
        className={`max-w-7xl mx-auto px-6 text-center scroll-fade-in ${sectionVisible ? 'visible' : ''}`}
      >
        <h2 className="text-3xl md:text-4xl font-semibold mb-12 text-white">
          Trusted by Leading Builders &amp; Developers
        </h2>

        <div className="relative overflow-hidden py-2">
          <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-black to-transparent z-10" />
          <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-black to-transparent z-10" />

          <div className="logo-marquee-track flex w-max items-center gap-8">
            {[...featuredClients, ...featuredClients].map((client, index) => (
              <div
                key={index}
                className="flex h-24 w-44 items-center justify-center rounded-xl border border-blue-500/25 bg-slate-900/70 px-4 shadow-md shadow-blue-500/10 transition-all duration-300 hover:border-blue-400/60 overflow-hidden"
              >
                <div className="flex h-[82%] w-[92%] items-center justify-center rounded-md bg-white p-1.5">
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    className="max-h-full max-w-full object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes logoMarquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .logo-marquee-track {
          animation: logoMarquee 26s linear infinite;
        }

        .logo-marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Testimonials;
